import api from '@pray/shared/utils/api';
import type { PaginatedListResponse } from '@pray/shared/utils/api/types/response';

import type { MemberCampaignResponse, PaginationParams } from './types';

export async function getMemberCampaigns(memberId: string, params: PaginationParams = {}) {
  const url = `/web/studio/users/${memberId}/campaigns`;

  const queryParams = {
    limit: params.limit ?? 50,
    offset: params.offset ?? 0,
  };

  const response = await api.executeGetRequest<PaginatedListResponse<MemberCampaignResponse>>(url, queryParams);

  return response.data;
}
